module.exports = __webpack_public_path__ + "static/media/en_icon.7357b239.svg";